import styled from 'styled-components';

import { typography } from './mixins';

// This component does not currently conform to the measurement and typography specifications that
// have been established in the Bricks UI project. Therefore, when updating the design standards
// within Bricks UI, it must be reflected and implemented in this component to maintain visual and
// functional coherence. It is important to review and adapt this component post-upgrade to ensure
// it complies with the new guidelines.

const HelperText = styled.p`
  color: ${({ theme }) => theme.palette.black};

  ${typography};

  font-size: ${({ theme }) => theme.toRem(13.28)};
  line-height: 1.45em;
`;

export default HelperText;
